import {Button, Col, Divider, Form, Input, message, Modal, Pagination, Row, Select, Space, Table} from "antd";
import {CheckOutlined, DeleteOutlined, EditOutlined, ExclamationCircleOutlined} from "@ant-design/icons";
import {useEffect, useState} from "react";
import {
    ACCOUNT_NAME_VALIDATION,
    COMMON_DROPDOWN,
    NOT_AVAILABLE,
    ONLY_NUMERIC_VALIDATION,
    PARAMETER_LIST,
    YYYY_MM_DD_HH_MM
} from "../../util/Constants";
import accountService from "../../service/accountService";
import ErrorHandler from "../../util/ErrorHandler";
import dayjs from "dayjs";
import {bookmarks_img} from "../../../AppImageConst";
import {ThirdPartyBankFilterDto} from "../../dto/ThirdPartyBankFilterDto";
import {
    MSG_DUPLICATE_TEMPLATE_NAME,
    MSG_ENTER_TEMPLATE_NAME,
    MSG_FAILED_TO_CHECK_TEMPLATE_NAME_ERROR,
    MSG_FAILED_TO_FETCH_BANK_BRANCH_LIST_ERROR,
    MSG_FAILED_TO_FETCH_BANK_LIST_ERROR,
    MSG_FAILED_TO_FETCH_THIRD_PARTY_BANK_TEMPLATE_ERROR,
    MSG_NO_CHANGES_TO_UPDATE,
    MSG_THIRD_PARTY_BANK_DETAILS_DELETED_FAILED,
    MSG_THIRD_PARTY_BANK_DETAILS_DELETED_SUCCESS,
    MSG_THIRD_PARTY_BANK_DETAILS_SAVE_FAILED,
    MSG_THIRD_PARTY_BANK_DETAILS_SAVED_SUCCESS,
    MSG_THIRD_PARTY_BANK_DETAILS_UPDATE_FAILED,
    MSG_THIRD_PARTY_BANK_DETAILS_UPDATE_SUCCESS
} from "../../util/Messages";
import {getLoggedUserCinNumber} from "../../security/KeyclockConfig";
import CommonFunction from "../../util/CommonFunction";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Validation from "../../util/Validation";
import transactionFetchService from "../../service/transactionFetchService";
import {DropdownListDto} from "../../dto/DropdownListDto";
import {InputDropdownParameterDto} from "../../dto/InputDropdownParameterDto";
import customerService from "../../service/customerService";
import modal from "antd/es/modal";
import {ThirdPartyBankDetailsDto} from "../../dto/ThirdPartyBankDetailsDto";

const ExistingTemplate = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [isUpdate, setUpdate] = useState<boolean>(false);
    const [isModalOpen, setModalOpen] = useState<boolean>(false);
    const [thirdPartyBankDetailList, setThirdPartyBankDetailList] = useState<ThirdPartyBankDetailsDto[]>([]);
    const [selectedThirdPartyBankDetail, setSelectedThirdPartyBankDetail] = useState<ThirdPartyBankDetailsDto | null>({});
    const [cinNumber, setCinNumber] = useState<string | null>();
    const [title, setTitle] = useState<string | null>("");
    const [savedTemplateName, setSavedTemplateName] = useState<string | null>("");
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 10,
    });

    const [filter] = useState<ThirdPartyBankFilterDto>({
        cin: null,
        page: 1,
        size: 10,
        sort: ['createdDate', 'desc']
    });
    const [form] = Form.useForm();
    const [bankList, setBankList] = useState<DropdownListDto[]>([]);
    const [bankBranchList, setBankBranchList] = useState<DropdownListDto[]>([]);
    useEffect(() => {

        let loggedUserCinNumber = getLoggedUserCinNumber();
        setCinNumber(loggedUserCinNumber)

        let filterDto = filter;
        filterDto.cin = loggedUserCinNumber
        fetchAllThirdPartyBankDetails(pagination.current, pagination.pageSize, filterDto)
    }, [])

    const columns = [
        {
            title: 'Template ID',
            dataIndex: 'id',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Account Name',
            dataIndex: 'accountName',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Template Name',
            dataIndex: 'accountNickName',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Account Number',
            dataIndex: 'accountNo',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Bank Name',
            dataIndex: 'bankName',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Branch Name',
            dataIndex: 'branchName',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Created Date Time',
            dataIndex: 'createdDate',
            render: (text: any, rec: any, index: number) => {
                return (<span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'Created By',
            dataIndex: 'createdBy',
            key: 'createdBy',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Modified Date Time',
            dataIndex: 'modifiedDate',
            render: (text: any, rec: any, index: number) => {
                return (<span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>)
            }
        },
        {
            title: 'Modified By',
            dataIndex: 'modifiedBy',
            key: 'modifiedBy',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Actions',
            align: 'center' as const,
            fixed: 'right' as const,
            render: (text: any, record: any) => (
                <Space size="middle">
                    <Button className='btn-action-outline-common btn-action-transfer'
                            icon={<EditOutlined/>} onClick={() => showModal(record, true)}>Update</Button>
                    <Button className='btn-action-outline-common btn-action-re-schedule'
                            icon={<DeleteOutlined/>} onClick={() => onDelete(record.id)}>Delete</Button>
                </Space>

            )
        },
    ]

    const showModal = (rec: ThirdPartyBankDetailsDto, isUpdate: boolean) => {
        setTitle(isUpdate ? "Update Third Party Bank Template" : "Add New Third Party Bank Template")
        if (isUpdate) {
            setSavedTemplateName(rec.accountNickName as string)
            setUpdate(true)
            setSelectedThirdPartyBankDetail(rec)
            form.setFieldsValue({
                accountHolderName: rec.accountName,
                accountNo: rec.accountNo,
                bankBranch: rec.branchId,
                bankName: rec.bankCode,
                templateName: rec.accountNickName,
            })
            getBranchList(rec.bankCode as number)
        } else {
            setUpdate(false)
            form.resetFields()
            setSelectedThirdPartyBankDetail(null)
        }

        setModalOpen(true)
        fetchOtherBankList(cinNumber as string)

    }

    const onDelete = (id: string) => {
        modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure you want to delete this template?`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: {style: {background: '#FF7400'}},
            className: 'confirm-dialog-box',
            onOk() {
                setLoading(true)
                accountService.deleteThirdPartyBankDetails(id).then(res => {
                    if (res.data) {
                        message.success(MSG_THIRD_PARTY_BANK_DETAILS_DELETED_SUCCESS)
                        fetchAllThirdPartyBankDetails(pagination.current, pagination.pageSize, filter)
                        setLoading(false)

                    } else {
                        message.error(MSG_THIRD_PARTY_BANK_DETAILS_DELETED_FAILED)
                        setLoading(false)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    setLoading(false)
                });
            },
            onCancel() {
                setLoading(false)
            }
        });
    }

    const fetchAllThirdPartyBankDetails = (page: number, pageSize: number, filterDto: ThirdPartyBankFilterDto) => {
        setLoading(true)

        filterDto.page = page - 1;
        filterDto.size = pageSize;

        accountService.fetchExistingBankTemplates(filterDto).then((res => {
            if (res.data !== null && res.data.results) {
                let results = res.data.results;
                setThirdPartyBankDetailList(results.thirdPartyBankDetailsDtos)
                setPagination({
                    current: results.page + 1, // Adjusting to be 1-based index
                    pageSize: results.size,
                    total: results.total,
                });
                setLoading(false)
            } else {
                setLoading(false)
                message.error(MSG_FAILED_TO_FETCH_THIRD_PARTY_BANK_TEMPLATE_ERROR).then();
            }
        })).catch((reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        });
    }

    const handlePaginationChange = (page: number, pageSize: number) => {
        fetchAllThirdPartyBankDetails(page, pageSize, filter);
    };
    const handleCancel = () => {
        setSelectedThirdPartyBankDetail(null)
        setModalOpen(false)
    }

    const validateTemplateName = (rule: any, value: any, callback: any) => {
        if (value) {
            if (value !== savedTemplateName) {
                transactionFetchService.validateThirdPartyBankTemplateName(value, cinNumber as string).then(res => {
                    if (res.data !== null) {
                        if (res.data.results) {
                            callback(MSG_DUPLICATE_TEMPLATE_NAME)
                        } else {
                            callback()
                        }
                    } else {
                        message.error(MSG_FAILED_TO_CHECK_TEMPLATE_NAME_ERROR).then();
                        callback(MSG_FAILED_TO_CHECK_TEMPLATE_NAME_ERROR)
                    }

                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    callback()
                })
            } else {
                callback()
            }
        } else {
            callback(MSG_ENTER_TEMPLATE_NAME)
        }
    };
    const onChangeOtherBank = (value: number) => {
        clearBankRelatedFields()
        getBranchList(value)
    }

    const onFinish = (values: any) => {
        form.validateFields().then()
        if (!isUpdate || checkChanges(values)) {
            modal.confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined/>,
                content: `Are you sure you want to ${isUpdate ? 'update' : 'save'} this template?`,
                okText: 'Yes',
                cancelText: 'No',
                okButtonProps: {style: {background: '#FF7400'}},
                className: 'confirm-dialog-box',
                onOk() {
                    setLoading(true)
                    handleCancel()
                    let thirdPartyBankDetail: ThirdPartyBankDetailsDto = {
                        accountName: values.accountHolderName,
                        accountNo: values.accountNo,
                        branchId: values.bankBranch,
                        bankCode: values.bankName,
                        accountNickName: values.templateName,
                        cin: cinNumber as string,
                        accountStatus: "ACTIVE",
                    }
                    if (isUpdate) {

                        thirdPartyBankDetail.id = selectedThirdPartyBankDetail?.id as number
                        accountService.updateThirdPartyBankDetails(thirdPartyBankDetail).then(res => {
                            if (res.data) {
                                message.success(MSG_THIRD_PARTY_BANK_DETAILS_UPDATE_SUCCESS)
                                fetchAllThirdPartyBankDetails(pagination.current, pagination.pageSize, filter)
                                setLoading(false)

                            } else {
                                message.error(MSG_THIRD_PARTY_BANK_DETAILS_UPDATE_FAILED)
                                setLoading(false)
                            }
                        }, (reason) => {
                            ErrorHandler.handleError(reason);
                            setLoading(false)
                        });

                    } else {
                        accountService.addNewThirdPartyBankDetails(thirdPartyBankDetail).then(res => {
                            if (res.data) {
                                message.success(MSG_THIRD_PARTY_BANK_DETAILS_SAVED_SUCCESS)
                                fetchAllThirdPartyBankDetails(pagination.current, pagination.pageSize, filter)
                                setLoading(false)

                            } else {
                                message.error(MSG_THIRD_PARTY_BANK_DETAILS_SAVE_FAILED)
                                setLoading(false)
                            }
                        }, (reason) => {
                            ErrorHandler.handleError(reason);
                            setLoading(false)
                        });
                    }
                },
                onCancel() {
                    setLoading(false)
                }
            });
        } else {
            message.warning(MSG_NO_CHANGES_TO_UPDATE)
        }
    }

    const checkChanges = (data: any) => {
        if (selectedThirdPartyBankDetail?.accountNickName != data.templateName) {
            return true;
        } else if (selectedThirdPartyBankDetail?.bankCode != data.bankName) {
            return true;
        } else if (selectedThirdPartyBankDetail?.branchId != data.bankBranch) {
            return true;
        } else if (selectedThirdPartyBankDetail?.accountNo != data.accountNo) {
            return true;
        } else if (selectedThirdPartyBankDetail?.accountName != data.accountHolderName) {
            return true;
        }
        return false;
    }

    const clearBankRelatedFields = () => {
        form.resetFields(["bankBranch", "accountNo", "accountHolderName"])
    }
    const fetchOtherBankList = (cinNumber: string) => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.BANK_LIST,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }

        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                setBankList(res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_BANK_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const getBranchList = (selectedBank: number) => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.BRANCH_LIST,
            findTextValue: "",
            parameterList: [[selectedBank], [PARAMETER_LIST.ACTIVE]]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                setBankBranchList(res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_BANK_BRANCH_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    return (
        <>

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: 'space-between'
                        }}>
                        <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                            <div className='header_icon header-icon-center'>
                                <img style={{width: 24}} src={bookmarks_img} alt=""/>
                            </div>
                            Third Party Bank Templates
                        </div>
                        <Button type="primary" icon={<FontAwesomeIcon icon={faPlus}/>} onClick={showModal}>Add
                            New</Button>
                    </h2>

                </Col>
            </Row>
            <Row gutter={[16, 16]} className='margin_top_20'>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Table scroll={{x: 'max-content'}} dataSource={thirdPartyBankDetailList} pagination={false}
                           columns={columns}
                           loading={loading}/>
                    <br/>
                    <Space style={{float: 'right'}}>
                        <Pagination
                            total={pagination.total ?? 0}
                            showTotal={(total: number) => `Total ${total} items`}
                            defaultPageSize={10}
                            defaultCurrent={pagination.current}
                            current={pagination.current}
                            onChange={handlePaginationChange}
                        />
                    </Space>
                </Col>

                <Modal title={title}
                       open={isModalOpen}
                       destroyOnClose={true}
                       maskClosable={false}
                       footer={null}
                       preserve={false}
                       onCancel={handleCancel}
                >
                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{marginTop: 8}}>
                            <Form
                                layout={"vertical"}
                                initialValues={{remember: true}}
                                onFinish={onFinish}
                                form={form}
                            >
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Form.Item
                                        label={<><span className='custom-astrix-pw-change'>*</span> Template Name </>}
                                        name={"templateName"}
                                        validateTrigger={["onBlur"]}
                                        rules={[{validator: validateTemplateName}]}>
                                        <Input size={'large'}
                                               placeholder={"Enter template name"}/>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Form.Item
                                        label="Name of the Bank"
                                        name={'bankName'}
                                        rules={
                                            [{
                                                required: true,
                                                message: 'Please select the bank name'
                                            }]}>
                                        <Select placement='bottomLeft'
                                                onChange={onChangeOtherBank}
                                                placeholder={"Select bank name"}
                                                showSearch listHeight={180}
                                                optionFilterProp="children"
                                                filterOption={(input: any, option: {
                                                    label: any;
                                                }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                getPopupContainer={(trigger: {
                                                    parentNode: any;
                                                }) => trigger.parentNode}
                                                options={bankList}
                                                size={'large'}
                                                style={{width: '100%'}}

                                        />

                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Form.Item
                                        label="Branch"
                                        name={'bankBranch'}
                                        rules={
                                            [{
                                                required: true,
                                                message: 'Please select the branch'
                                            }]}>

                                        <Select placement='bottomLeft'
                                                defaultSelected={""}
                                                placeholder={"Select branch"}
                                                showSearch
                                                listHeight={180}
                                                optionFilterProp="children"
                                                filterOption={(input: any, option: {
                                                    label: any;
                                                }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                                getPopupContainer={(trigger: {
                                                    parentNode: any;
                                                }) => trigger.parentNode}
                                                options={bankBranchList}
                                                size={'large'}
                                                style={{width: '100%'}}

                                        />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Form.Item
                                        label="Account Number"
                                        name={"accountNo"}
                                        onKeyPress={Validation.isNumberWithoutDot}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please enter account number'
                                            },
                                            {
                                                max: 30,
                                                message: 'The maximum length is 30 numbers'
                                            },
                                            {
                                                pattern: ONLY_NUMERIC_VALIDATION,
                                                message: 'These special characters are not allowed'
                                            }
                                        ]}>
                                        <Input size={'large'}
                                               placeholder={"Enter account number"}/>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <Form.Item
                                        label="Account Holder`s Name"
                                        name={"accountHolderName"}
                                        onKeyPress={Validation.onlyAlphabeticWithSpace}
                                        rules={[{
                                            required: true,
                                            message: 'Please enter account holder`s name'
                                        },
                                            {
                                                max: 50,
                                                message: 'The maximum length is 50 characters'
                                            },
                                            {
                                                pattern: ACCOUNT_NAME_VALIDATION,
                                                message: 'Special characters and numbers are not allowed'
                                            }
                                        ]}>
                                        <Input type="text"
                                               size={'large'}
                                               placeholder={"Enter account holder`s name"}/>
                                    </Form.Item>

                                </Col>
                                <Divider></Divider>

                                <Col span={24}>
                                    <Space style={{float: 'right'}}>

                                        <Button icon={<CheckOutlined/>} type="primary" htmlType="submit">Submit</Button>
                                    </Space>
                                </Col>
                            </Form>
                        </Col>
                    </Row>

                </Modal>
            </Row>
        </>


    )
}
export default ExistingTemplate